
export const printParameterTranslation = Object.freeze({
  PRODUCT_DEFINITION: 'Product name',
  CUSTOMER_TYPE: 'Customer type'
});